import "./Success.scss";
import { useState, useEffect } from "react";
import SuccessGif from "./../../assets/images/success.gif";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "./../../context/LanguageContext";

const Success = () => {
  const { t } = useLanguage(); // Get the translation function
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  // Separate useEffect for countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);
    if (countdown <= 0) {
      clearInterval(timer);
      navigate("/subscriptions", { replace: true });
    }
    return () => clearInterval(timer);
  }, [countdown, navigate]);

  return (
    <div className="success">
      <div className="message__container">
        <img src={SuccessGif} alt={t("successTransactionAlt")} />
        <h3>{t("purchaseSuccess")}</h3>
        <h4>{t("trackOrderInfo")}</h4>
        <h4>
          {t("redirectCountdownPrefix")}{" "}
          <span>
            {countdown} {t("seconds")}
          </span>
        </h4>
      </div>
    </div>
  );
};

export default Success;
